import React, { ComponentType, PureComponent } from 'react';
import { AppStateContext } from '../services/AppStateContext';

const withAppStateContext = <P extends object>(Component: ComponentType<P>) => {
  class WithContext extends PureComponent<P> {
    render() {
      return <AppStateContext.Consumer>{value => <Component {...this.props} {...value} />}</AppStateContext.Consumer>;
    }
  }

  return WithContext;
};

export default withAppStateContext;
